import { baseRestApi, sendToastOnQueryFulfilled } from '@src/utils/rtkQuery';
import { abbreviateId, type CareOrder } from '@talos/kyoko';

interface ActivateWorkingOrderParams {
  orderID: string;
  targetRevision: number;
}

const workingOrderActivationApi = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    activateWorkingOrder: builder.mutation<CareOrder[], ActivateWorkingOrderParams>({
      query: ({ orderID, targetRevision }) => ({
        method: 'POST',
        url: `/care/working/orders/${orderID}/activate`,
        headers: { 'Content-Type': 'application/json' },
        body: {
          // Backend uses the current revision as an optimistic concurrency guard.
          TargetRevision: targetRevision,
        },
      }),
      onQueryStarted: sendToastOnQueryFulfilled({
        successMessage: ({ orderID }) => `Netted order #${abbreviateId(orderID)} approved.`,
        errorMessage: 'Could not approve netted order',
      }),
    }),
  }),
});

export const { useActivateWorkingOrderMutation } = workingOrderActivationApi;
